import Api from './api.service'

export default {
  createClinic (object) {
    return Api().post('clinic/create', object)
  },
  updateClinic (object) {
    return Api().put('clinic/edit/' + object.id, object.object)
  },
  clinicList (filter) {
    return Api().get('clinic/get', { params: filter })
  },
  getClinic (id) {
    return Api().get('clinic/get/' + id)
  }
}